var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "personnel-kpi-container" }, [
    _vm._m(0),
    _c("div", { staticClass: "person-filter" }, [
      _vm._m(1),
      _c("div", { staticClass: "filter-controls" }, [
        _c(
          "label",
          { staticClass: "filter-field" },
          [
            _c("span", [_vm._v("Phòng ban")]),
            _c(
              "el-select",
              {
                attrs: { size: "small", placeholder: "Chọn phòng ban" },
                on: { change: _vm.onDepartmentChange },
                model: {
                  value: _vm.selectedDepartment,
                  callback: function ($$v) {
                    _vm.selectedDepartment = $$v
                  },
                  expression: "selectedDepartment",
                },
              },
              _vm._l(_vm.departments, function (department) {
                return _c("el-option", {
                  key: department.id,
                  attrs: {
                    label: department.departmentName,
                    value: department.id,
                  },
                })
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "label",
          { staticClass: "filter-field employee-field" },
          [
            _c("span", [_vm._v("Nhân viên")]),
            _c(
              "el-select",
              {
                ref: "employeeSelect",
                attrs: {
                  size: "small",
                  filterable: "",
                  remote: "",
                  "default-first-option": "",
                  clearable: "",
                  "remote-method": _vm.filterEmployeeOptions,
                  placeholder: "Gõ tên nhân viên...",
                  loading: _vm.loadingEmployees,
                  disabled:
                    _vm.loadingEmployees || !_vm.filteredEmployees.length,
                },
                on: { change: _vm.onEmployeeChange },
                nativeOn: {
                  "!keydown": function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.searchEmployeesOnEnter.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.selectedEmployee,
                  callback: function ($$v) {
                    _vm.selectedEmployee = $$v
                  },
                  expression: "selectedEmployee",
                },
              },
              [
                _vm._l(_vm.employeeSearchResults, function (employee) {
                  return _c("el-option", {
                    key: employee.id,
                    attrs: { label: employee.name, value: employee.id },
                  })
                }),
                _vm.employeeSearchQuery && !_vm.employeeSearchResults.length
                  ? _c("el-option", {
                      attrs: {
                        disabled: "",
                        label: "Không tìm thấy nhân viên",
                        value: "",
                      },
                    })
                  : _vm._e(),
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "selected-person" }, [
        _c("span", { staticClass: "person-avatar" }, [
          _vm._v(_vm._s(_vm.currentEmployee.initials)),
        ]),
        _c("span", [
          _c("strong", [_vm._v(_vm._s(_vm.currentEmployee.name))]),
          _c("small", [_vm._v(_vm._s(_vm.currentDepartmentName))]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "source-panel" }, [
      _c("h3", [_vm._v("Nhóm dữ liệu dự kiến")]),
      _c(
        "div",
        { staticClass: "source-grid" },
        _vm._l(_vm.sources, function (source) {
          return _c(
            "button",
            {
              key: source.key,
              class: [
                "source-card",
                { selected: _vm.selectedSource === source.key },
              ],
              style: { borderLeftColor: source.color },
              attrs: {
                type: "button",
                "aria-pressed": _vm.selectedSource === source.key,
              },
              on: {
                click: function ($event) {
                  return _vm.selectSource(source.key)
                },
              },
            },
            [
              _c(
                "span",
                {
                  staticClass: "source-icon",
                  style: {
                    color: source.color,
                    backgroundColor: source.background,
                  },
                },
                [_c("i", { class: source.icon })]
              ),
              _c("span", { staticClass: "source-copy" }, [
                _c("strong", [_vm._v(_vm._s(source.title))]),
                _c("small", [_vm._v(_vm._s(source.description))]),
              ]),
            ]
          )
        }),
        0
      ),
    ]),
    _c("div", { staticClass: "chart-panel" }, [
      _c("div", { staticClass: "panel-heading" }, [
        _c("div", [
          _c("h3", [
            _vm._v(
              _vm._s(_vm.currentSource.title) +
                " · " +
                _vm._s(_vm.currentEmployee.name)
            ),
          ]),
          _c("p", [
            _vm._v("Nhân viên: "),
            _c("strong", [_vm._v(_vm._s(_vm.currentEmployee.name))]),
            _vm._v(" · Nhóm dữ liệu: "),
            _c("strong", [_vm._v(_vm._s(_vm.currentSource.title))]),
          ]),
        ]),
        _c("div", { staticClass: "chart-heading-actions" }, [
          _vm.selectedSource === "ATTENDANCE" && _vm.loadingAttendance
            ? _c("span", { staticClass: "discussion-badge" }, [
                _vm._v("Đang tải dữ liệu"),
              ])
            : _vm.selectedSource === "ATTENDANCE" && _vm.attendanceData
            ? _c("span", { staticClass: "live-data-badge" }, [
                _vm._v("Dữ liệu từ hệ thống"),
              ])
            : _vm.selectedSource === "STUDENT_ATTENDANCE" &&
              _vm.loadingStudentAttendance
            ? _c("span", { staticClass: "discussion-badge" }, [
                _vm._v("Đang tải dữ liệu"),
              ])
            : _vm.selectedSource === "STUDENT_ATTENDANCE" &&
              _vm.studentAttendanceData
            ? _c("span", { staticClass: "live-data-badge" }, [
                _vm._v("Dữ liệu từ hệ thống"),
              ])
            : _vm.selectedSource === "TIMETABLE" && _vm.loadingTimetable
            ? _c("span", { staticClass: "discussion-badge" }, [
                _vm._v("Đang tải dữ liệu"),
              ])
            : _vm.selectedSource === "TIMETABLE" && _vm.timetableData
            ? _c("span", { staticClass: "live-data-badge" }, [
                _vm._v("Dữ liệu từ hệ thống"),
              ])
            : _vm.selectedSource === "EVALUATION" && _vm.loadingEvaluation
            ? _c("span", { staticClass: "discussion-badge" }, [
                _vm._v("Đang tải dữ liệu"),
              ])
            : _vm.selectedSource === "EVALUATION" && _vm.evaluationData
            ? _c("span", { staticClass: "live-data-badge" }, [
                _vm._v("Dữ liệu từ hệ thống"),
              ])
            : _vm.selectedSource === "MENU" && _vm.loadingMenuKpi
            ? _c("span", { staticClass: "discussion-badge" }, [
                _vm._v("Đang tải dữ liệu"),
              ])
            : _vm.selectedSource === "MENU" && _vm.menuKpiData
            ? _c("span", { staticClass: "live-data-badge" }, [
                _vm._v("Dữ liệu từ hệ thống"),
              ])
            : _vm.selectedSource === "ALBUM" && _vm.loadingAlbumKpi
            ? _c("span", { staticClass: "discussion-badge" }, [
                _vm._v("Đang tải dữ liệu"),
              ])
            : _vm.selectedSource === "ALBUM" && _vm.albumKpiData
            ? _c("span", { staticClass: "live-data-badge" }, [
                _vm._v("Dữ liệu từ hệ thống"),
              ])
            : _vm._e(),
          _vm.selectedSource !== "EVALUATION"
            ? _c(
                "div",
                {
                  staticClass: "scope-filter",
                  attrs: { "aria-label": "Phạm vi thống kê" },
                },
                [
                  _vm._m(2),
                  _c(
                    "div",
                    { staticClass: "scope-options" },
                    _vm._l(_vm.availableScopes, function (scope) {
                      return _c(
                        "button",
                        {
                          key: scope.value,
                          class: [
                            "scope-button",
                            { active: _vm.activeScope === scope.value },
                          ],
                          attrs: {
                            type: "button",
                            "aria-pressed": _vm.activeScope === scope.value,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.changeScope(scope.value)
                            },
                          },
                        },
                        [_vm._v(_vm._s(scope.label))]
                      )
                    }),
                    0
                  ),
                ]
              )
            : _c(
                "div",
                {
                  staticClass: "evaluation-filter",
                  attrs: { "aria-label": "Loại nhận xét" },
                },
                _vm._l(_vm.evaluationTypes, function (type) {
                  return _c(
                    "button",
                    {
                      key: type.value,
                      class: [
                        "evaluation-filter-button",
                        { active: _vm.evaluationType === type.value },
                      ],
                      attrs: {
                        type: "button",
                        "aria-pressed": _vm.evaluationType === type.value,
                      },
                      on: {
                        click: function ($event) {
                          _vm.evaluationType = type.value
                        },
                      },
                    },
                    [_vm._v(_vm._s(type.label))]
                  )
                }),
                0
              ),
          _vm.selectedSource !== "EVALUATION"
            ? _c(
                "div",
                { staticClass: "period-picker" },
                [
                  _vm.activeScope === "DAY"
                    ? _c("el-date-picker", {
                        key: "personnel-day-picker",
                        attrs: {
                          type: "date",
                          size: "small",
                          format: "dd/MM/yyyy",
                          placeholder: "Chọn ngày",
                          clearable: false,
                          align: "right",
                          "append-to-body": true,
                          "picker-options": [
                            "STUDENT_ATTENDANCE",
                            "ALBUM",
                          ].includes(_vm.selectedSource)
                            ? _vm.studentAttendanceDatePickerOptions
                            : undefined,
                        },
                        on: { change: _vm.resetAttendanceDay },
                        model: {
                          value: _vm.selectedDayDate,
                          callback: function ($$v) {
                            _vm.selectedDayDate = $$v
                          },
                          expression: "selectedDayDate",
                        },
                      })
                    : _vm._e(),
                  _vm.activeScope === "WEEK"
                    ? _c("el-date-picker", {
                        key: "personnel-week-picker",
                        attrs: {
                          type: "week",
                          size: "small",
                          format: "Tuần WW (yyyy)",
                          placeholder: "Chọn tuần",
                          clearable: false,
                          align: "right",
                          "append-to-body": true,
                          "picker-options":
                            _vm.selectedSource === "ALBUM"
                              ? _vm.albumWeekPickerOptions
                              : _vm.weekPickerOptions,
                        },
                        on: { change: _vm.resetAttendanceDay },
                        model: {
                          value: _vm.selectedWeekDate,
                          callback: function ($$v) {
                            _vm.selectedWeekDate = $$v
                          },
                          expression: "selectedWeekDate",
                        },
                      })
                    : _vm._e(),
                  _vm.activeScope === "MONTH"
                    ? _c("el-date-picker", {
                        key: "personnel-month-picker",
                        attrs: {
                          type: "month",
                          size: "small",
                          format: "MM/yyyy",
                          placeholder: "Chọn tháng",
                          clearable: false,
                          align: "right",
                          "append-to-body": true,
                          "picker-options":
                            _vm.selectedSource === "ALBUM"
                              ? _vm.albumMonthPickerOptions
                              : undefined,
                        },
                        on: { change: _vm.resetAttendanceDay },
                        model: {
                          value: _vm.selectedMonthDate,
                          callback: function ($$v) {
                            _vm.selectedMonthDate = $$v
                          },
                          expression: "selectedMonthDate",
                        },
                      })
                    : _vm._e(),
                  _vm.activeScope === "RANGE"
                    ? _c("el-date-picker", {
                        key: "personnel-range-picker",
                        attrs: {
                          type: "daterange",
                          size: "small",
                          format: "dd/MM/yyyy",
                          "range-separator": "-",
                          "start-placeholder": "Từ ngày",
                          "end-placeholder": "Đến ngày",
                          clearable: false,
                          align: "right",
                          "append-to-body": true,
                          "unlink-panels": true,
                          "picker-options":
                            _vm.selectedSource === "ALBUM"
                              ? _vm.albumRangePickerOptions
                              : undefined,
                        },
                        on: { change: _vm.resetAttendanceDay },
                        model: {
                          value: _vm.selectedDateRange,
                          callback: function ($$v) {
                            _vm.selectedDateRange = $$v
                          },
                          expression: "selectedDateRange",
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "evaluation-period-picker" },
                [
                  _vm.evaluationType === "DAILY"
                    ? _c("el-date-picker", {
                        key: "evaluation-day-picker",
                        attrs: {
                          type: "date",
                          size: "small",
                          format: "dd/MM/yyyy",
                          "value-format": "yyyy-MM-dd",
                          placeholder: "Chọn ngày nhận xét",
                          clearable: false,
                          "picker-options": _vm.evaluationDatePickerOptions,
                        },
                        model: {
                          value: _vm.selectedEvaluationDate,
                          callback: function ($$v) {
                            _vm.selectedEvaluationDate = $$v
                          },
                          expression: "selectedEvaluationDate",
                        },
                      })
                    : _vm.evaluationType === "WEEKLY"
                    ? _c("el-date-picker", {
                        key: "evaluation-week-picker",
                        attrs: {
                          type: "week",
                          size: "small",
                          format: "Tuần WW (yyyy)",
                          placeholder: "Chọn tuần nhận xét",
                          clearable: false,
                          "picker-options": _vm.evaluationDatePickerOptions,
                        },
                        model: {
                          value: _vm.selectedEvaluationWeek,
                          callback: function ($$v) {
                            _vm.selectedEvaluationWeek = $$v
                          },
                          expression: "selectedEvaluationWeek",
                        },
                      })
                    : _vm.evaluationType === "MONTHLY"
                    ? _c("el-date-picker", {
                        key: "evaluation-month-picker",
                        attrs: {
                          type: "month",
                          size: "small",
                          format: "MM/yyyy",
                          "value-format": "yyyy-MM",
                          placeholder: "Chọn tháng nhận xét",
                          clearable: false,
                          "picker-options": _vm.evaluationDatePickerOptions,
                        },
                        model: {
                          value: _vm.selectedEvaluationMonth,
                          callback: function ($$v) {
                            _vm.selectedEvaluationMonth = $$v
                          },
                          expression: "selectedEvaluationMonth",
                        },
                      })
                    : [
                        _c("el-date-picker", {
                          key: "evaluation-year-picker",
                          attrs: {
                            type: "year",
                            size: "small",
                            format: "yyyy",
                            "value-format": "yyyy",
                            placeholder: "Năm dương lịch",
                            clearable: false,
                            "picker-options": _vm.evaluationYearPickerOptions,
                          },
                          on: { change: _vm.updateEvaluationAnchor },
                          model: {
                            value: _vm.selectedEvaluationYear,
                            callback: function ($$v) {
                              _vm.selectedEvaluationYear = $$v
                            },
                            expression: "selectedEvaluationYear",
                          },
                        }),
                        _c("el-input-number", {
                          attrs: {
                            size: "small",
                            min: 1,
                            max: 99,
                            "controls-position": "right",
                            placeholder: "Đợt",
                          },
                          model: {
                            value: _vm.selectedEvaluationPeriodNumber,
                            callback: function ($$v) {
                              _vm.selectedEvaluationPeriodNumber = $$v
                            },
                            expression: "selectedEvaluationPeriodNumber",
                          },
                        }),
                        _c("el-date-picker", {
                          key: "evaluation-anchor-picker",
                          attrs: {
                            type: "date",
                            size: "small",
                            format: "dd/MM/yyyy",
                            "value-format": "yyyy-MM-dd",
                            placeholder: "Ngày mốc",
                            clearable: false,
                            "picker-options": _vm.evaluationAnchorPickerOptions,
                          },
                          model: {
                            value: _vm.selectedEvaluationAnchorDate,
                            callback: function ($$v) {
                              _vm.selectedEvaluationAnchorDate = $$v
                            },
                            expression: "selectedEvaluationAnchorDate",
                          },
                        }),
                      ],
                ],
                2
              ),
          !_vm.isRatioSource && _vm.selectedSource !== "ATTENDANCE"
            ? _c(
                "div",
                {
                  staticClass: "chart-type-options",
                  attrs: { "aria-label": "Loại biểu đồ" },
                },
                [
                  _c(
                    "button",
                    {
                      class: { active: _vm.chartType === "BAR" },
                      attrs: {
                        type: "button",
                        "aria-pressed": _vm.chartType === "BAR",
                      },
                      on: {
                        click: function ($event) {
                          _vm.chartType = "BAR"
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-data-analysis" }),
                      _vm._v(" Cột"),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      class: { active: _vm.chartType === "PIE" },
                      attrs: {
                        type: "button",
                        "aria-pressed": _vm.chartType === "PIE",
                      },
                      on: {
                        click: function ($event) {
                          _vm.chartType = "PIE"
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-pie-chart" }),
                      _vm._v(" Tròn"),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ]),
      _vm.selectedSource === "ATTENDANCE"
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingAttendance,
                  expression: "loadingAttendance",
                },
              ],
              staticClass: "attendance-chart",
            },
            [
              _vm.attendanceError
                ? _c(
                    "div",
                    { staticClass: "attendance-load-state error-state" },
                    [
                      _c("i", { staticClass: "el-icon-warning-outline" }),
                      _c("span", [_vm._v(_vm._s(_vm.attendanceError))]),
                    ]
                  )
                : !_vm.attendanceData && !_vm.loadingAttendance
                ? _c("div", { staticClass: "attendance-load-state" }, [
                    _c("i", { staticClass: "el-icon-info" }),
                    _c("span", [
                      _vm._v(
                        "Chọn nhân viên và khoảng ngày để tải số liệu chấm công."
                      ),
                    ]),
                  ])
                : _vm.attendanceData
                ? [
                    _c("div", { staticClass: "chart-caption" }, [
                      _c("strong", [
                        _vm._v(
                          "Chấm công của " + _vm._s(_vm.currentEmployee.name)
                        ),
                      ]),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.activeScope === "DAY"
                              ? "Chi tiết trạng thái và giờ chấm công"
                              : _vm.periodLabel +
                                  " · " +
                                  _vm.attendanceData.elapsedDays +
                                  " ngày đã qua"
                          )
                        ),
                      ]),
                    ]),
                    _vm.activeScope !== "DAY"
                      ? _c("div", { staticClass: "attendance-overview" }, [
                          _c("div", { staticClass: "attendance-donut-card" }, [
                            _c(
                              "div",
                              { staticClass: "attendance-donut-wrap" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "donut",
                                    style: _vm.attendancePieStyle,
                                  },
                                  [
                                    _c("div", { staticClass: "donut-hole" }, [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.attendanceRecordedDayCount)
                                        ),
                                      ]),
                                      _c("small", [_vm._v("ngày tính tỷ lệ")]),
                                    ]),
                                  ]
                                ),
                                _vm._l(
                                  _vm.attendancePieLabels,
                                  function (item) {
                                    return _c(
                                      "span",
                                      {
                                        key: item.key,
                                        staticClass: "donut-percent-label",
                                        class: item.key,
                                        style: item.style,
                                        attrs: {
                                          title:
                                            item.label +
                                            ": " +
                                            item.percent +
                                            "%",
                                        },
                                      },
                                      [_vm._v(_vm._s(item.percent) + "%")]
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "attendance-summary-grid" },
                            [
                              _vm._l(
                                _vm.attendanceStatusSummary,
                                function (item) {
                                  return _c(
                                    "div",
                                    {
                                      key: item.key,
                                      staticClass: "attendance-summary-item",
                                      class: item.key,
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "legend-dot",
                                        class: item.key,
                                      }),
                                      _c("span", [_vm._v(_vm._s(item.label))]),
                                      _c("strong", [
                                        _vm._v(_vm._s(item.value) + " ngày"),
                                      ]),
                                    ]
                                  )
                                }
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "attendance-extra-item late",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openAttendanceEvents("late")
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "el-icon-time" }),
                                  _c("span", [_vm._v("Đi muộn")]),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.attendanceSummary.late) +
                                        " ngày"
                                    ),
                                  ]),
                                  _c("small", [_vm._v("Nhấn để xem chi tiết")]),
                                ]
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "attendance-extra-item early",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openAttendanceEvents("early")
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "el-icon-right" }),
                                  _c("span", [_vm._v("Về sớm")]),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.attendanceSummary.early) +
                                        " ngày"
                                    ),
                                  ]),
                                  _c("small", [_vm._v("Nhấn để xem chi tiết")]),
                                ]
                              ),
                            ],
                            2
                          ),
                        ])
                      : _vm._e(),
                    _vm.activeScope !== "DAY"
                      ? _c("p", { staticClass: "attendance-calendar-note" }, [
                          _vm._v(
                            _vm._s(_vm.attendanceData.elapsedDays) +
                              " ngày đã qua · " +
                              _vm._s(_vm.attendanceData.unknownScheduleDays) +
                              " ngày thiếu lịch, không tính vào tỷ lệ."
                          ),
                        ])
                      : _vm._e(),
                    _vm.activeScope !== "DAY" && _vm.attendanceDays.length
                      ? _c("div", { staticClass: "attendance-timeline" }, [
                          _vm._m(3),
                          _c(
                            "div",
                            { staticClass: "timeline-scroll" },
                            _vm._l(_vm.attendanceDays, function (day, index) {
                              return _c(
                                "button",
                                {
                                  key: index,
                                  class: [
                                    "timeline-day",
                                    day.status,
                                    {
                                      selected:
                                        _vm.selectedAttendanceDayIndex ===
                                        index,
                                    },
                                  ],
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      _vm.selectedAttendanceDayIndex = index
                                    },
                                  },
                                },
                                [
                                  _c("span", [_vm._v(_vm._s(day.label))]),
                                  _c("i", {
                                    staticClass: "legend-dot",
                                    class: day.status,
                                  }),
                                  _c("small", [_vm._v(_vm._s(day.shortLabel))]),
                                ]
                              )
                            }),
                            0
                          ),
                        ])
                      : _vm._e(),
                    _vm.selectedAttendanceDay
                      ? _c("div", { staticClass: "attendance-detail" }, [
                          _c(
                            "div",
                            { staticClass: "attendance-detail-heading" },
                            [
                              _c("div", [
                                _c("strong", [
                                  _vm._v(
                                    "Chi tiết " +
                                      _vm._s(_vm.selectedAttendanceDay.label)
                                  ),
                                ]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.activeScope === "DAY"
                                        ? "Trạng thái trong ngày"
                                        : "Ngày được chọn trong dải thống kê"
                                    )
                                  ),
                                ]),
                              ]),
                              _c(
                                "span",
                                {
                                  staticClass: "attendance-status-badge",
                                  class: _vm.selectedAttendanceDay.status,
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.selectedAttendanceDay.statusLabel
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "attendance-detail-grid" }, [
                            _c("div", [
                              _c("span", [_vm._v("Giờ đến")]),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.selectedAttendanceDay.arriveTime)
                                ),
                              ]),
                            ]),
                            _c("div", [
                              _c("span", [_vm._v("Giờ về")]),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.selectedAttendanceDay.leaveTime)
                                ),
                              ]),
                            ]),
                            _c("div", [
                              _c("span", [_vm._v("Đi muộn")]),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.selectedAttendanceDay.status ===
                                      "present"
                                      ? _vm.selectedAttendanceDay.lateMinutes +
                                          " phút"
                                      : "—"
                                  )
                                ),
                              ]),
                            ]),
                            _c("div", [
                              _c("span", [_vm._v("Về sớm")]),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.selectedAttendanceDay.status ===
                                      "present"
                                      ? _vm.selectedAttendanceDay.earlyMinutes +
                                          " phút"
                                      : "—"
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                          _c("div", { staticClass: "attendance-sessions" }, [
                            _c("div", [
                              _c("span", [_vm._v("Sáng")]),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.selectedAttendanceDay.sessions.morning
                                  )
                                ),
                              ]),
                            ]),
                            _c("div", [
                              _c("span", [_vm._v("Chiều")]),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.selectedAttendanceDay.sessions.afternoon
                                  )
                                ),
                              ]),
                            ]),
                            _c("div", [
                              _c("span", [_vm._v("Tối")]),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.selectedAttendanceDay.sessions.evening
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                          _c("p", [
                            _vm._v(
                              "Đi muộn và về sớm là thông tin bổ sung của ngày đi làm; ngày thiếu cấu hình lịch được báo riêng và không tính vào biểu đồ."
                            ),
                          ]),
                        ])
                      : _c("div", { staticClass: "attendance-load-state" }, [
                          _c("i", { staticClass: "el-icon-date" }),
                          _c("span", [
                            _vm._v(
                              "Khoảng thời gian đã chọn chưa có ngày đã qua để hiển thị."
                            ),
                          ]),
                        ]),
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          visible: _vm.attendanceEventDialogVisible,
                          width: "560px",
                          "append-to-body": "",
                          "custom-class": "attendance-event-dialog",
                        },
                        on: {
                          "update:visible": function ($event) {
                            _vm.attendanceEventDialogVisible = $event
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "attendance-dialog-title",
                            attrs: { slot: "title" },
                            slot: "title",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "attendance-dialog-icon",
                                class: _vm.attendanceEventType,
                              },
                              [
                                _c("i", {
                                  class:
                                    _vm.attendanceEventType === "late"
                                      ? "el-icon-time"
                                      : "el-icon-right",
                                }),
                              ]
                            ),
                            _c("div", [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.attendanceEventTitle)),
                              ]),
                              _c("small", [
                                _vm._v(
                                  _vm._s(_vm.periodLabel) +
                                    " · " +
                                    _vm._s(_vm.currentEmployee.name)
                                ),
                              ]),
                            ]),
                          ]
                        ),
                        _c("div", { staticClass: "attendance-event-summary" }, [
                          _c("div", [
                            _c("small", [_vm._v("Số ngày phát sinh")]),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.attendanceEventRows.length) + " "
                              ),
                              _c("span", [_vm._v("ngày")]),
                            ]),
                          ]),
                          _c("div", { class: _vm.attendanceEventType }, [
                            _c("small", [
                              _vm._v(
                                _vm._s(
                                  _vm.attendanceEventType === "late"
                                    ? "Tổng thời gian đi muộn"
                                    : "Tổng thời gian về sớm"
                                )
                              ),
                            ]),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.attendanceEventTotalMinutes) + " "
                              ),
                              _c("span", [_vm._v("phút")]),
                            ]),
                          ]),
                        ]),
                        _vm.attendanceEventRows.length
                          ? _c(
                              "div",
                              { staticClass: "attendance-event-list" },
                              _vm._l(
                                _vm.attendanceEventRows,
                                function (row, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: row.label,
                                      staticClass: "attendance-event-row",
                                      class: _vm.attendanceEventType,
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "attendance-event-index",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              String(index + 1).padStart(2, "0")
                                            )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "attendance-event-date",
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(_vm._s(row.label)),
                                          ]),
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.attendanceEventType ===
                                                  "late"
                                                  ? "Đi muộn"
                                                  : "Về sớm"
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "attendance-event-time",
                                        },
                                        [
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.attendanceEventType ===
                                                  "late"
                                                  ? "Giờ đến"
                                                  : "Giờ về"
                                              )
                                            ),
                                          ]),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.attendanceEventType ===
                                                  "late"
                                                  ? row.arriveTime
                                                  : row.leaveTime
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "attendance-event-minutes",
                                        },
                                        [_vm._v(_vm._s(row.minutes) + " phút")]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                          : _c(
                              "div",
                              { staticClass: "attendance-event-empty" },
                              [
                                _c("span", [
                                  _c("i", { staticClass: "el-icon-check" }),
                                ]),
                                _c("strong", [
                                  _vm._v("Không có ngày phát sinh"),
                                ]),
                                _c("small", [
                                  _vm._v(
                                    "Nhân viên không " +
                                      _vm._s(
                                        _vm.attendanceEventType === "late"
                                          ? "đi muộn"
                                          : "về sớm"
                                      ) +
                                      " trong " +
                                      _vm._s(_vm.periodLabel.toLowerCase()) +
                                      "."
                                  ),
                                ]),
                              ]
                            ),
                      ]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm.selectedSource === "TIMETABLE" &&
          (_vm.loadingTimetable || _vm.timetableError || !_vm.timetableData)
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingTimetable,
                  expression: "loadingTimetable",
                },
              ],
              staticClass: "attendance-load-state",
            },
            [
              _c("i", {
                class: _vm.timetableError
                  ? "el-icon-warning-outline"
                  : "el-icon-loading",
              }),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.timetableError || "Đang tải KPI thời khóa biểu...")
                ),
              ]),
            ]
          )
        : _vm.selectedSource === "MENU" &&
          (_vm.loadingMenuKpi || _vm.menuKpiError || !_vm.menuKpiData)
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingMenuKpi,
                  expression: "loadingMenuKpi",
                },
              ],
              staticClass: "attendance-load-state",
            },
            [
              _c("i", {
                class: _vm.menuKpiError
                  ? "el-icon-warning-outline"
                  : "el-icon-loading",
              }),
              _c("span", [
                _vm._v(_vm._s(_vm.menuKpiError || "Đang tải KPI thực đơn...")),
              ]),
            ]
          )
        : _vm.selectedSource === "ALBUM" &&
          (_vm.loadingAlbumKpi || _vm.albumKpiError || !_vm.albumKpiData)
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingAlbumKpi,
                  expression: "loadingAlbumKpi",
                },
              ],
              staticClass: "attendance-load-state",
            },
            [
              _c("i", {
                class: _vm.albumKpiError
                  ? "el-icon-warning-outline"
                  : "el-icon-loading",
              }),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.albumKpiError ||
                      (_vm.currentEmployee.id
                        ? "Đang tải KPI album..."
                        : "Chọn nhân viên để xem KPI album.")
                  )
                ),
              ]),
            ]
          )
        : _vm.selectedSource === "STUDENT_ATTENDANCE"
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingStudentAttendance,
                  expression: "loadingStudentAttendance",
                },
              ],
              staticClass: "ratio-class-panel",
            },
            [
              _c("div", { staticClass: "chart-caption" }, [
                _c("strong", [_vm._v("Học sinh đã được điểm danh theo lớp")]),
                _c("span", [
                  _vm._v(
                    "Lớp hiện phụ trách · Sĩ số và trạng thái lấy theo ngày " +
                      _vm._s(_vm.periodLabel)
                  ),
                ]),
              ]),
              _vm.studentAttendanceError
                ? _c(
                    "div",
                    { staticClass: "attendance-load-state error-state" },
                    [
                      _c("i", { staticClass: "el-icon-warning-outline" }),
                      _c("span", [_vm._v(_vm._s(_vm.studentAttendanceError))]),
                    ]
                  )
                : _vm.loadingStudentAttendance
                ? _c("div", { staticClass: "attendance-load-state" }, [
                    _c("i", { staticClass: "el-icon-loading" }),
                    _c("span", [
                      _vm._v("Đang tải số liệu điểm danh theo lớp..."),
                    ]),
                  ])
                : _vm.studentAttendanceData && !_vm.classMetrics.length
                ? _c("div", { staticClass: "attendance-load-state" }, [
                    _c("i", { staticClass: "el-icon-school" }),
                    _c("span", [
                      _vm._v("Nhân viên hiện chưa được phân công lớp nào."),
                    ]),
                  ])
                : _vm.studentAttendanceData
                ? _c(
                    "div",
                    { staticClass: "ratio-class-scroll" },
                    _vm._l(_vm.classMetrics, function (metric) {
                      return _c(
                        "div",
                        { key: metric.id, staticClass: "ratio-class-card" },
                        [
                          metric.dataStatus === "NO_STUDENTS"
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "ratio-class-empty" },
                                  [
                                    _c("i", { staticClass: "el-icon-user" }),
                                    _c("strong", [_vm._v(_vm._s(metric.name))]),
                                    _c("span", [
                                      _vm._v(
                                        "Không có học sinh trong lớp vào ngày này"
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            : [
                                _c(
                                  "div",
                                  {
                                    staticClass: "donut class-donut",
                                    style: _vm.ratioClassPieStyle(metric),
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "donut-hole class-donut-hole",
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(metric.completionRate) + "%"
                                          ),
                                        ]),
                                        _c("small", [_vm._v("đã điểm danh")]),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "strong",
                                  { staticClass: "ratio-class-name" },
                                  [_vm._v(_vm._s(metric.name))]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "ratio-class-count" },
                                  [
                                    _vm._v(
                                      _vm._s(metric.value) +
                                        " / " +
                                        _vm._s(metric.total) +
                                        " học sinh đã được điểm danh"
                                    ),
                                  ]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "ratio-class-unmarked" },
                                  [
                                    _vm._v(
                                      "Chưa điểm danh: " +
                                        _vm._s(metric.unmarked) +
                                        " học sinh"
                                    ),
                                  ]
                                ),
                              ],
                        ],
                        2
                      )
                    }),
                    0
                  )
                : _c("div", { staticClass: "attendance-load-state" }, [
                    _c("i", { staticClass: "el-icon-info" }),
                    _c("span", [
                      _vm._v("Chọn nhân viên để xem số liệu điểm danh."),
                    ]),
                  ]),
              _vm.studentAttendanceData && _vm.classMetrics.length
                ? _c("p", { staticClass: "class-note" }, [
                    _vm._v(
                      "Tiến độ ghi nhận điểm danh theo lớp; không phụ thuộc nhân viên nào thực hiện."
                    ),
                  ])
                : _vm._e(),
            ]
          )
        : _vm.isRatioSource && _vm.classMetrics.length
        ? _c("div", { staticClass: "ratio-class-panel" }, [
            _c("div", { staticClass: "chart-caption" }, [
              _c("strong", [
                _vm._v(
                  _vm._s(
                    _vm.selectedSource === "STUDENT_ATTENDANCE"
                      ? "Học sinh đã được điểm danh theo lớp"
                      : _vm.classRatioTitle
                  )
                ),
              ]),
              _c("span", [
                _vm._v("Mỗi biểu đồ là một lớp nhân viên phụ trách"),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "ratio-class-scroll" },
              _vm._l(_vm.classMetrics, function (metric) {
                return _c(
                  "div",
                  { key: metric.id, staticClass: "ratio-class-card" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "donut class-donut",
                        style: _vm.ratioClassPieStyle(metric),
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "donut-hole class-donut-hole" },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  metric.completionRate === null ||
                                    metric.completionRate === undefined
                                    ? metric.total
                                      ? `${(
                                          (metric.value / metric.total) *
                                          100
                                        ).toFixed(1)}%`
                                      : "—"
                                    : `${Number(metric.completionRate).toFixed(
                                        1
                                      )}%`
                                )
                              ),
                            ]),
                            _c("small", [
                              _vm._v(
                                _vm._s(
                                  _vm.selectedSource === "STUDENT_ATTENDANCE"
                                    ? "đã điểm danh"
                                    : "đã nhận xét"
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _c("strong", { staticClass: "ratio-class-name" }, [
                      _vm._v(_vm._s(metric.name)),
                    ]),
                    _c("span", { staticClass: "ratio-class-count" }, [
                      _vm._v(
                        _vm._s(metric.value) +
                          " / " +
                          _vm._s(metric.total) +
                          " học sinh " +
                          _vm._s(
                            _vm.selectedSource === "STUDENT_ATTENDANCE"
                              ? "đã được điểm danh"
                              : "được nhận xét"
                          )
                      ),
                    ]),
                    _vm.selectedSource === "EVALUATION" && metric.total === 0
                      ? _c("span", { staticClass: "ratio-class-unmarked" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                metric.rosterTotal
                                  ? `Sĩ số ${metric.rosterTotal}; không có học sinh đủ điều kiện trong mẫu số.`
                                  : "Lớp không có học sinh trong kỳ."
                              ) +
                              "\n          "
                          ),
                        ])
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
            _c("p", { staticClass: "class-note" }, [
              _vm._v(
                _vm._s(
                  _vm.selectedSource === "STUDENT_ATTENDANCE"
                    ? "Tình trạng điểm danh của lớp, không phụ thuộc người thực hiện."
                    : "Chỉ tính học sinh được nhân viên đang chọn nhận xét."
                )
              ),
            ]),
          ])
        : _vm.classMetrics.length
        ? _c("div", { staticClass: "class-chart-layout" }, [
            _c("div", { staticClass: "class-chart-main" }, [
              _c("div", { staticClass: "chart-caption" }, [
                _c("strong", [_vm._v(_vm._s(_vm.chartTitle))]),
                _c("span", [_vm._v(_vm._s(_vm.chartSubtitle))]),
              ]),
              _vm.chartType === "BAR"
                ? _c(
                    "div",
                    { staticClass: "class-bars" },
                    _vm._l(_vm.classMetrics, function (metric) {
                      return _c(
                        "div",
                        {
                          key: metric.id,
                          class: [
                            "class-bar-item",
                            { "read-only": _vm.selectedSource === "ALBUM" },
                          ],
                          on: {
                            click: function ($event) {
                              _vm.selectedSource !== "ALBUM" &&
                                (_vm.selectedClassId = metric.id)
                            },
                          },
                        },
                        [
                          _c("strong", [_vm._v(_vm._s(metric.value))]),
                          _c("div", { staticClass: "bar-track" }, [
                            _c("div", {
                              staticClass: "bar-value",
                              style: {
                                height: _vm.barHeight(metric) + "%",
                                backgroundColor: _vm.currentSource.color,
                              },
                            }),
                          ]),
                          _c("small", [_vm._v(_vm._s(metric.name))]),
                        ]
                      )
                    }),
                    0
                  )
                : _c("div", { staticClass: "pie-area" }, [
                    _c(
                      "div",
                      { staticClass: "pie-visual" },
                      [
                        _c(
                          "div",
                          { staticClass: "donut", style: _vm.classPieStyle },
                          [
                            _c("div", { staticClass: "donut-hole" }, [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.pieCenterValue)),
                              ]),
                              _c("small", [_vm._v(_vm._s(_vm.pieCenterLabel))]),
                            ]),
                          ]
                        ),
                        ["TIMETABLE", "MENU", "ALBUM"].includes(
                          _vm.selectedSource
                        ) && _vm.classMetrics.length <= 4
                          ? _vm._l(_vm.classMetrics, function (metric, index) {
                              return _c(
                                "span",
                                {
                                  key: metric.id,
                                  staticClass: "pie-slice-label",
                                  style: _vm.pieSliceLabelStyle(index),
                                },
                                [
                                  _c("strong", [_vm._v(_vm._s(metric.value))]),
                                  _vm._v(" " + _vm._s(_vm.countUnit) + " · "),
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.pieShare(metric)) + "%"),
                                  ]),
                                ]
                              )
                            })
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c("p", { staticClass: "pie-caption" }, [
                      _vm._v(
                        "Phân bổ số " + _vm._s(_vm.countUnit) + " giữa các lớp"
                      ),
                    ]),
                  ]),
              _vm.selectedSource === "MENU"
                ? _c("div", { staticClass: "menu-kpi-total" }, [
                    _c("span", [
                      _vm._v(
                        "Tổng hồ sơ thực đơn trong " +
                          _vm._s(_vm.periodLabel.toLowerCase())
                      ),
                    ]),
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.menuKpiData ? _vm.menuKpiData.totalPosts : 0
                        ) + " lượt đăng"
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm.selectedSource === "ALBUM" && _vm.albumKpiData
                ? _c("div", { staticClass: "menu-kpi-total album-kpi-total" }, [
                    _c("span", [
                      _vm._v(
                        "Album lớp: " +
                          _vm._s(_vm.albumKpiData.totalClassPosts) +
                          " lượt · " +
                          _vm._s(_vm.albumKpiData.uniqueClassAlbums) +
                          " album duy nhất · " +
                          _vm._s(_vm.albumResponsePeriodLabel)
                      ),
                    ]),
                    _c("strong", [
                      _vm._v(
                        "Toàn trường: " +
                          _vm._s(_vm.albumKpiData.schoolAlbumCount) +
                          " · Đã duyệt " +
                          _vm._s(_vm.albumKpiData.approvedSchoolAlbumCount) +
                          " · Chờ duyệt " +
                          _vm._s(_vm.albumKpiData.pendingSchoolAlbumCount)
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _c(
              "div",
              { staticClass: "class-list" },
              [
                _c("h4", [
                  _vm._v("Các lớp phụ trách "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.classMetrics.length) + " lớp"),
                  ]),
                ]),
                _vm._l(_vm.classMetrics, function (metric, index) {
                  return _c(
                    "div",
                    {
                      key: metric.id,
                      class: [
                        "class-row",
                        {
                          active:
                            _vm.selectedSource !== "ALBUM" &&
                            _vm.selectedClassMetric.id === metric.id,
                          "read-only": _vm.selectedSource === "ALBUM",
                        },
                      ],
                      on: {
                        click: function ($event) {
                          _vm.selectedSource !== "ALBUM" &&
                            (_vm.selectedClassId = metric.id)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "class-row-name" }, [
                        _c("i", {
                          staticClass: "class-color-dot",
                          style: {
                            backgroundColor:
                              _vm.chartColors[index % _vm.chartColors.length],
                          },
                        }),
                        _vm._v(" " + _vm._s(metric.name)),
                      ]),
                      _c("span", { staticClass: "class-row-values" }, [
                        _c("strong", [
                          _vm._v(
                            _vm._s(metric.value) + " " + _vm._s(_vm.countUnit)
                          ),
                          _vm.selectedSource === "TIMETABLE"
                            ? _c("span", [
                                _vm._v(" · " + _vm._s(metric.percent) + "%"),
                              ])
                            : _vm.selectedSource === "MENU" ||
                              _vm.selectedSource === "ALBUM" ||
                              _vm.chartType === "PIE"
                            ? _c("span", [
                                _vm._v(
                                  " · " + _vm._s(_vm.pieShare(metric)) + "%"
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm.selectedSource === "ALBUM"
                          ? _c("small", [
                              _vm._v(
                                "Đã duyệt " +
                                  _vm._s(metric.approvedAlbumCount) +
                                  " · Chờ duyệt " +
                                  _vm._s(metric.pendingAlbumCount)
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  )
                }),
                _c("p", { staticClass: "class-note" }, [
                  _vm._v(
                    _vm._s(
                      _vm.selectedSource === "TIMETABLE"
                        ? "Đếm kế hoạch có nội dung theo lớp-tuần, tính theo tài khoản tạo ban đầu."
                        : _vm.selectedSource === "MENU"
                        ? "Theo ngày tạo hồ sơ; một bản ghi thực đơn ngày hoặc một hồ sơ tệp tuần là một lượt. Sửa hồ sơ cũ không tạo lượt mới."
                        : _vm.selectedSource === "ALBUM"
                        ? "Ghi nhận album V2 theo tài khoản tạo ban đầu; album nhiều lớp tính một lượt ở mỗi lớp. Lớp hiển thị theo phân công hiện tại (CURRENT_ASSIGNMENT); album toàn trường được thống kê riêng."
                        : "Chỉ đếm nội dung do nhân viên đã chọn đăng cho lớp."
                    )
                  ),
                ]),
                _vm.selectedSource === "MENU" &&
                _vm.menuKpiData &&
                _vm.menuKpiData.ambiguousDailySlots > 0
                  ? _c("p", { staticClass: "class-note data-warning" }, [
                      _vm._v(
                        "\n          Có " +
                          _vm._s(_vm.menuKpiData.ambiguousDailySlots) +
                          " ngày có bản ghi trùng với người tạo khác nhau; các ngày này đã bị loại khỏi số lượt thực đơn ngày.\n        "
                      ),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ])
        : _c(
            "div",
            { staticClass: "empty-classes" },
            [
              _c("i", { staticClass: "el-icon-school" }),
              _vm.selectedSource === "EVALUATION"
                ? [
                    _vm.loadingEvaluation
                      ? _c("strong", [_vm._v("Đang tải KPI nhận xét...")])
                      : _vm.evaluationError
                      ? _c("strong", [_vm._v(_vm._s(_vm.evaluationError))])
                      : _vm.evaluationData
                      ? _c("strong", [
                          _vm._v(
                            "Không có lớp được phân công hoặc không có dữ liệu trong kỳ."
                          ),
                        ])
                      : _c("strong", [
                          _vm._v(
                            "Chọn nhân viên để xem KPI nhận xét theo lớp."
                          ),
                        ]),
                  ]
                : _vm.selectedSource === "ALBUM"
                ? [
                    _vm.albumKpiData
                      ? _c("strong", [
                          _vm._v("Chưa có album lớp trong kỳ đã chọn."),
                        ])
                      : _c("strong", [
                          _vm._v("Chọn nhân viên để xem KPI album."),
                        ]),
                    _vm.albumKpiData
                      ? _c("span", [
                          _vm._v(
                            "Lớp phụ trách hiện tại: " +
                              _vm._s(_vm.albumKpiData.classes.length) +
                              " · Album toàn trường: " +
                              _vm._s(_vm.albumKpiData.schoolAlbumCount) +
                              " (đã duyệt " +
                              _vm._s(
                                _vm.albumKpiData.approvedSchoolAlbumCount
                              ) +
                              ", chờ duyệt " +
                              _vm._s(_vm.albumKpiData.pendingSchoolAlbumCount) +
                              ")."
                          ),
                        ])
                      : _c("span", [
                          _vm._v("Chọn nhân viên để tải dữ liệu Album V2."),
                        ]),
                  ]
                : [
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.selectedSource === "TIMETABLE"
                            ? "Nhân viên chưa có lớp được phân công hoặc kế hoạch trong kỳ."
                            : _vm.selectedSource === "MENU"
                            ? "Nhân viên hiện chưa được phân công lớp nào."
                            : "Nhân viên chưa có lớp phụ trách trong kỳ thống kê."
                        )
                      ),
                    ]),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.selectedSource === "TIMETABLE"
                            ? "Thử chọn nhân viên hoặc khoảng thời gian khác."
                            : _vm.selectedSource === "MENU"
                            ? "Thực đơn được phân bổ theo lớp đang phụ trách hiện tại."
                            : "Chọn nhân viên khác để xem biểu đồ theo lớp."
                        )
                      ),
                    ]),
                  ],
            ],
            2
          ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "module-header" }, [
      _c("div", { staticClass: "header-main" }, [
        _c("span", { staticClass: "module-icon" }, [
          _c("i", { staticClass: "el-icon-data-analysis" }),
        ]),
        _c("div", [
          _c("div", { staticClass: "title-line" }, [
            _c("h2", [_vm._v("Thống Kê KPI Nhân Sự")]),
          ]),
          _c("p", [
            _vm._v(
              "Chọn nhóm dữ liệu và phạm vi thống kê để định hình chỉ số KPI nhân sự."
            ),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "filter-intro" }, [
      _c("span", { staticClass: "filter-icon" }, [
        _c("i", { staticClass: "el-icon-user" }),
      ]),
      _c("div", [
        _c("h3", [_vm._v("Xem KPI theo nhân viên")]),
        _c("p", [
          _vm._v(
            "Chọn nhân viên trong danh sách của trường để xem KPI cá nhân."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "scope-label" }, [
      _c("i", { staticClass: "el-icon-date" }),
      _vm._v(" Phạm vi thống kê:"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "timeline-heading" }, [
      _c("strong", [_vm._v("Trạng thái từng ngày")]),
      _c("span", [_vm._v("Chọn ngày để xem chi tiết")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }